import { useState } from 'react';
import { faqs } from '@/mocks/landing';
import SectionTitle from './SectionTitle';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-white pb-16 md:pb-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <SectionTitle title="Questions, answered" />
        <div className="divide-y divide-[#eff0f1] border-y border-[#eff0f1]">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between gap-4 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className={`font-semibold text-sm md:text-base ${isOpen ? 'text-[#2f51d6]' : 'text-[#1f2329]'}`}>{faq.q}</span>
                  <span className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors ${isOpen ? 'bg-[#eef2ff] text-[#2f51d6]' : 'bg-[#f5f6f7] text-[#646a73]'}`}>
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`} />
                  </span>
                </button>
                {isOpen && <p className="pb-5 pr-10 text-sm text-[#646a73] leading-relaxed">{faq.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
